<div class="grid-filter-section-header-content">
    @if (isSearchGrid$ | async) {

    <h-grid-result-search-header></h-grid-result-search-header>

    } @if (currentCategory$ | async; as currentCategory) {

    <h1 tabindex="-1">
        <!-- Grid Filter  => Parent Collection Title -->
        <span class="header-title-parent"> {{ currentCategory.masterCategoryName }}&nbsp; </span>
        <!-- Grid Filter - Current Collection Title -->
        <div class="header-title-current" [attr.role]="'text'" [attr.data-testid]="'header-title-current'">
            <span>
                {{ currentCategory.name }}
                @if (facetDisplayName$ | async; as facetDisplayName) {

                <span class="facet-separator"> | </span>
                {{ facetDisplayName }}

                }
            </span>
        </div>
    </h1>
    @if (isBrowserMode) {
    <span
        class="header-title-current-number-result"
        [attr.aria-hidden]="'true'"
        [attr.data-testid]="'number-current-result'"
        >({{ collectionSize }})</span
    >
    } @if (collectionSize) {

    <p class="sr-only" data-nosnippet>
        <ng-container *ngTemplateOutlet="accessibilityTemplate"></ng-container>
    </p>

    }

    <!-- For screen reader only. Informs the user that the products list has been updated -->
    <p
        hSrOnlyNoSnippet
        [attr.aria-live]="'polite'"
        [attr.aria-atomic]="'true'"
        [attr.aria-hidden]="hideTotalUpdatedItems">
        <span i18n="@@hermes.accessibility.update">Update</span>
        @if (collectionSize) {

        <ng-container *ngTemplateOutlet="accessibilityTemplate"></ng-container>

        }
    </p>
    <ng-template #accessibilityTemplate>
        <span>&nbsp;{{ collectionSize }} </span>
        @if (collectionSize && collectionSize < 2) {
        <span>
            <span i18n="@@hermes.accessibility.product">item</span>
        </span>
        } @else {

        <span i18n="@@hermes.accessibility.products">items</span>

        }
    </ng-template>

    }
</div>
